import { Outlet } from 'react-router-dom'

import { BlockedBanner } from '@/app/layout/blocked-banner'
import { ImpersonationBanner } from '@/app/layout/impersonation-banner'
import { Topbar } from '@/app/layout/topbar'

export function AppLayout() {
  return (
    <div className="flex h-screen flex-col bg-[var(--app-bg)] text-[var(--color-text)]">
      <ImpersonationBanner />
      <BlockedBanner />
      <Topbar />
      <main className="min-h-0 w-full flex-1 overflow-y-auto px-2 py-2 sm:px-4 sm:py-4">
        <Outlet />
      </main>
    </div>
  )
}
